export default {
  filter: '',
  loaded_init: false,
  roles: []
}
